/**
 * Atmosphere — the CRT overlays.
 *
 * Purely decorative and mounted once at App level instead of once per page
 * (v2 duplicated these three fixed layers on both routes, which meant two
 * competing `position: fixed` stacks at the same z-index).
 *
 * All layers are pointer-events:none so they can never swallow a tap or break
 * scrolling — that is the whole reason they live outside the scroll content.
 */

import React from 'react';

export default function Atmosphere() {
  return (
    <>
      <div className="noise-overlay" aria-hidden="true" />
      <div className="vignette" aria-hidden="true" />
      <div className="scanline-effect" aria-hidden="true" />
      <div className="crt-overlay" aria-hidden="true" />
    </>
  );
}
